import React from 'react';
import { Component } from 'react';

export default class ServicoAnimaisEstimacaoTurissul extends Component {

    render() {
        return (
            <>
                <div className="menu-accordion-heading">
                    <a className="menu-accordion-toggle" href="#item-compra-9">
                        Animais de Estimação
                        <i className="fa fa-caret-down p-float-right"></i>
                    </a>
                </div>
                <div id="item-compra-9" className="menu-accordion-body"
                    style={{ overFlow: 'hidden', display: 'none' }}>
                    <div className="menu-accordion-inner">
                        <h3 className="menu-accordion-inner-trigger js-accordion-inner-trigger">
                            Posso levar meu pet?
                            <i className="fa fa-caret-down p-float-right"></i>
                        </h3>
                        <div className="menu-accordion-inner-collapse">
                            <p>Sim.</p>
                            <p>É permitido o transporte de animais de pequeno porte, desde que sejam cumpridas as condições estabelecidas para a viagem.</p>
                            <p>O passageiro deverá:</p>
                            <p style={{'padding-left': '5px'}}>• Transportar o pet em <b>caixa de transporte adequada</b>;</p>
                            <p style={{'padding-left': '5px'}}>• Apresentar a <b>carteira de vacinação atualizada</b>;</p>
                            <p style={{'padding-left': '5px'}}>• Adquirir uma <b>passagem extra em seu nome</b>, permitindo que o pet viaje ao seu lado.</p>
                        </div>
                        <h3 className="menu-accordion-inner-trigger js-accordion-inner-trigger">
                            Quais cuidados devo ter ao transportar meu pet?
                            <i className="fa fa-caret-down p-float-right"></i>
                        </h3>
                        <div className="menu-accordion-inner-collapse">
                            <p>Para proporcionar uma viagem mais tranquila, segura e confortável ao animal, recomendamos alguns cuidados:</p>
                            <p style={{'padding-left': '5px'}}>• <b>Hidratação</b>: mantenha o pet hidratado durante a viagem, oferecendo água em pequenas quantidades ao longo do trajeto;</p>
                            <p style={{'padding-left': '5px'}}>• <b>Alimentação</b>: evite alimentar o animal imediatamente antes da viagem para reduzir o risco de enjoos;</p>
                            <p style={{'padding-left': '5px'}}>• <b>Paradas</b>: quando permitido e seguro, aproveite as paradas para que o pet possa fazer suas necessidades e se movimentar;</p>
                            <p style={{'padding-left': '5px'}}>• <b>Caixa de transporte</b>: utilize uma caixa adequada ao tamanho do animal, segura e bem ventilada;</p>
                            <p style={{'padding-left': '5px'}}>• <b>Documentação</b>: leve a carteira de vacinação atualizada e demais documentos que possam ser exigidos;</p>
                            <p style={{'padding-left': '5px'}}>• <b>Identificação</b>: recomenda-se que o pet utilize identificação, como coleira contendo nome e telefone do responsável.</p>
                            <p>Esses cuidados ajudam a reduzir o estresse e proporcionam mais conforto e segurança para o pet durante toda a viagem. 🐶🐱</p>
                        </div>
                        
                    </div>
                </div>
            </>
        )
    }
}